import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIos';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import parse from 'html-react-parser';
import map from 'lodash/map';

import Container from '../../containers/Container';
import Grid from '../../components/Grid';
import HexaPicto from '../../components/HexaPicto';
import Picto from '../../components/Picto';
import Button from '../../components/Button';
import PdfLoader from '../../utils/PdfLoader';
import styles, { LOW_BUTTON, MEDIUM_BUTTON, HIGH_BUTTON } from './styles';

class HomeTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      row: null,
      col: null,
      currentRow: 0,
    };
    this.onClose = this.onClose.bind(this);
    this.buttonColor = { low: LOW_BUTTON, medium: MEDIUM_BUTTON, high: HIGH_BUTTON };
    this.rowsArray = this.getRowsArray();
    this.onBack = this.onBack.bind(this);
    this.onNext = this.onNext.bind(this);
  }

  getRowsArray() {
    const { data } = this.props;
    const { rows } = data.home.table;
    const array = [];
    map(rows, (value, ref) => {
      array.push(ref);
    });
    return array;
  }

  onOpen(row, col) {
    this.setState({ row, col });
  }

  onClose() {
    this.setState({ row: null, col: null });
  }

  onBack() {
    this.setState(prevState => ({
      currentRow: prevState.currentRow === 0 ? this.rowsArray.length - 1 : prevState.currentRow - 1,
    }));
  }

  onNext() {
    this.setState(prevState => ({
      currentRow: prevState.currentRow === this.rowsArray.length - 1 ? 0 : prevState.currentRow + 1,
    }));
  }

  renderPopup() {
    const { classes, data } = this.props;
    const { table: block } = data.home;
    const { row, col } = this.state;
    if (!row) {
      return null;
    }
    const colData = row[col];
    return (
      <Dialog
        maxWidth="md"
        fullWidth
        scroll="paper"
        open
        onClose={this.onClose}
        PaperProps={{ square: true, className: `${classes.dialogPaper} ${classes[`dialogPaper_${colData.type}`]}` }}
      >
        <DialogTitle className={classes.dialogTitle}>
          <Grid justify="space-between">
            <Typography key="title" variant="h4">
              {parse(block['popup-title'])}
            </Typography>
            <IconButton key="icon" color="inherit" onClick={this.onClose} className={classes.dialogClose}>
              <HexaPicto width={35} height={35} type="cross" color={this.buttonColor[colData.type]} />
            </IconButton>
          </Grid>
          <div className={`${classes.dialogSep} ${classes[`dialogSep_${colData.type}`]}`}></div>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {colData.popup.map((item, idx) => (
            <div key={idx} className={classes.dialogMoreInfo}>
              <Typography variant="h5" className={classes.dialogMoreInfoNum}>
                {parse(item.num)}
              </Typography>
              <Typography variant="h5" className={classes.dialogMoreInfoTitle}>
                {parse(item.title)}
              </Typography>
              <Button color={this.buttonColor[colData.type]} size="small" onClick={PdfLoader(item.pdf)}>
                {parse(block['popup-button'])}
              </Button>
            </div>
          ))}
        </DialogContent>
      </Dialog>
    );
  }

  renderTitle() {
    const { classes, data } = this.props;
    const { table: block } = data.home;
    return (
      <>
        <Grid md={6} spacing={3} alignItems="center" className={classes.titleGrid}>
          <Typography key="title" variant="h3" className={classes.title}>
            {parse(block.title)}
          </Typography>
          <div key="legend" className={classes.legendContainer}>
            <Grid spacing={2}>
              <Grid.Item key="title" xs={5}>
                <Typography className={classes.legendTitle} variant="body2">
                  {parse(block.legend.title)}
                </Typography>
                <Typography className={classes.legendDesc} variant="body2">
                  {parse(block.legend.desc)}
                </Typography>
              </Grid.Item>
              <Grid.Item key="legend" xs={7} className={classes.legendBars}>
                <Grid spacing={2} xs={4}>
                  <div key="low" className={classes.legendItem}>
                    <div className={`${classes.legendBar} ${classes.legendBarLow}`}></div>
                    <Typography className={classes.legendBarTitle} variant="body2">
                      {parse(block.legend.low)}
                    </Typography>
                  </div>
                  <div key="medium" className={classes.legendItem}>
                    <div className={`${classes.legendBar} ${classes.legendBarMedium}`}></div>
                    <Typography className={classes.legendBarTitle} variant="body2">
                      {parse(block.legend.medium)}
                    </Typography>
                  </div>
                  <div key="high" className={classes.legendItem}>
                    <div className={`${classes.legendBar} ${classes.legendBarHigh}`}></div>
                    <Typography className={classes.legendBarTitle} variant="body2">
                      {parse(block.legend.high)}
                    </Typography>
                  </div>
                </Grid>
              </Grid.Item>
            </Grid>
          </div>
        </Grid>
        <div className={classes.titleSep}></div>
      </>
    );
  }

  renderTableTitle() {
    const { classes, data } = this.props;
    const { table: block } = data.home;
    return (
      <Grid spacing={0} className={classes.gridTableTitle}>
        <Grid.Item xs={12} sm={12} md={3} key="button">
          <div className={classes.buttonPdfContainer}>
            <Button color="red" onClick={PdfLoader(block.pdf)}>
              {parse(block.button)}
            </Button>
          </div>
        </Grid.Item>
        <Grid.Item xs={12} sm={12} md={9} key="title">
          <div className={classes.activitiesTitleContainer}>
            <Typography className={classes.activitiesTitle} variant="body2">
              {parse(block['activities-title'])}
            </Typography>
          </div>
        </Grid.Item>
      </Grid>
    );
  }

  renderTableHeaderResponsive() {
    const { classes } = this.props;
    const { currentRow } = this.state;
    return (
      <div className={classes.tableHeaderResponsive}>
        <IconButton
          color="inherit"
          onClick={this.onBack}
          className={`${classes.tableHeaderResponsiveArrow} ${classes.tableHeaderResponsiveArrowLeft}`}
        >
          <ArrowBackIcon />
        </IconButton>
        <Picto
          className={classes.tableHeaderResponsivePicto}
          name={this.rowsArray[currentRow]}
          width={70}
          height={70}
        />
        <IconButton
          color="inherit"
          onClick={this.onNext}
          className={`${classes.tableHeaderResponsiveArrow} ${classes.tableHeaderResponsiveArrowRight}`}
        >
          <ArrowForwardIcon />
        </IconButton>
      </div>
    );
  }

  renderTableHeader() {
    const { classes, data } = this.props;
    const { table: block } = data.home;
    return (
      <Grid spacing={0} xs={3} alignItems="stretch" className={classes.gridTableHeader}>
        <div className={classes.resourceTitleContainer} key="title">
          <Typography className={classes.resourceTitle}>{parse(block['resource-title'])}</Typography>
        </div>
        <div className={classes.columnHeader} key="col1">
          <Typography component="div" className={classes.headerTitle}>
            {parse(block.header.col1)}
          </Typography>
        </div>
        <div className={classes.columnHeader} key="col2">
          <Typography component="div" className={classes.headerTitle}>
            {parse(block.header.col2)}
          </Typography>
        </div>
        <div className={classes.columnHeader} key="col3">
          <Typography component="div" className={classes.headerTitle}>
            {parse(block.header.col3)}
          </Typography>
        </div>
      </Grid>
    );
  }

  renderTable() {
    const { classes, data } = this.props;
    const { table: block } = data.home;
    return <div className={classes.tableContainer}>{map(block.rows, (row, ref) => this.renderRow(row, ref))}</div>;
  }

  renderSqrt(row, col) {
    const { classes, data } = this.props;
    const { table: block } = data.home;
    return (
      <div key={col} className={classes.rowSqrtContainer}>
        <div className={classes.rowHeader}>
          <div className={classes.rowHeaderText}>
            <Typography variant="body2" className={classes.rowHeaderTextInner}>
              {parse(block.header[col])}
            </Typography>
          </div>
        </div>
        <ButtonBase
          focusRipple
          className={`${classes.rowSqrt} ${classes[`rowSqrt_${row[col].type}`]}`}
          onClick={() => this.onOpen(row, col)}
        >
          <Typography className={classes.tableSqrtContent}>{parse(row[col].content)}</Typography>
          <HexaPicto
            className={classes.hexaPlus}
            width={24}
            height={21}
            type="plus"
            color={this.buttonColor[row[col].type]}
          />
        </ButtonBase>
      </div>
    );
  }

  renderRow(row, ref) {
    const { classes } = this.props;
    const { currentRow } = this.state;
    const show = this.rowsArray[currentRow] === ref;
    return (
      <Grid
        key={ref}
        spacing={0}
        xs={12}
        sm={12}
        md={3}
        alignItems="stretch"
        className={`${classes.rowGrid} ${show ? classes.showRowGrid : ''}`}
      >
        <div key="picto" className={classes.tableRowLabelContainer}>
          <div className={classes.tablePictoContainer}>
            <div className={classes.tablePicto}>
              <Picto name={ref} width="100%" height="100%" />
            </div>
          </div>
          <Typography className={classes.tableRowTitle} variant="body2">
            {parse(row.title)}
          </Typography>
        </div>
        {this.renderSqrt(row, 'col1')}
        {this.renderSqrt(row, 'col2')}
        {this.renderSqrt(row, 'col3')}
      </Grid>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <Container className={classes.container} id="home-table">
        {this.renderPopup()}
        {this.renderTitle()}
        {this.renderTableTitle()}
        {this.renderTableHeader()}
        {this.renderTableHeaderResponsive()}
        {this.renderTable()}
      </Container>
    );
  }
}

HomeTable.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HomeTable);
